import { userUploadWatcherSaga } from './upload.saga'
import { searchUserListWatcherSaga } from './list.saga'
import { decodeJwtWatcherSaga } from './decode-jwt.saga'
import { permissionListWatcherSaga } from './access.sagas'
import { participantEditSupervisorWatcherSaga } from './updateUserSupervisors.saga'

export const sagas = [
  userUploadWatcherSaga(),
  searchUserListWatcherSaga(),
  decodeJwtWatcherSaga(),
  permissionListWatcherSaga(),
  participantEditSupervisorWatcherSaga(),
]
export default sagas
